export class CancelPurchase {
  motivo?: string;
  descricao?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
  observacoes?: string;
  novoDocumento?: boolean;
  movimentaStock?: boolean;
}
